import { render, staticRenderFns } from "./SchoolLeaveSectionExportLegend.vue?vue&type=template&id=d72606a4&scoped=true&"
import script from "./SchoolLeaveSectionExportLegend.vue?vue&type=script&lang=js&"
export * from "./SchoolLeaveSectionExportLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72606a4",
  null
  
)

export default component.exports